// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "org.dota168",
    name: "MetaWallet",
    homepage: "http://www.dota168.org/",
    image_id: "a18337ad-433f-47c0-ea57-8a6199835e00",
    app: {
        browser: null,
        ios: null,
        android: "http://www.dota168.org/",
        mac: null,
        windows: null,
        linux: null,
        chrome: "http://www.dota168.org/",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "metawallet://com.metawallet.client",
        universal: "http://www.dota168.org/",
    },
    desktop: {
        native: "metawallet://",
        universal: "http://www.dota168.org/",
    },
};
//# sourceMappingURL=index.js.map